if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      // ---------- NEW HELPERS ----------
      isVisible(el) {
        if (!el) return false;
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
        // If the element or its label is not in the layout, offsetParent is null (except for fixed)
        return !!(el.offsetParent || style.position === 'fixed');
      }

      labelFor(input) {
        if (!input?.id) return null;
        return this.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      }

      selectFirstVisibleEnabledInGroup(group) {
        // Radio buttons
        const radios = group.querySelectorAll('input[type="radio"]');
        if (radios.length) {
          const candidates = Array.from(radios).filter((r) => {
            const lab = this.labelFor(r);
            return !r.disabled && this.isVisible(r) && (!lab || this.isVisible(lab));
          });

          // If already have a visible checked radio, keep it
          const alreadyChecked = candidates.find((r) => r.checked);
          if (alreadyChecked) return false;

          const first = candidates[0];
          if (first) {
            first.checked = true;
            first.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
          return false;
        }

        // Select dropdowns
        const select = group.querySelector('select');
        if (select) {
          const opts = Array.from(select.options).filter((o) => !o.disabled);
          const current = select.selectedOptions[0];
          if (current && !current.disabled) return false;

          const first = opts[0];
          if (first) {
            select.value = first.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
        return false;
      }

      ensureValidDefaults() {
        // Run once the DOM inside this element is ready
        const groups = this.querySelectorAll('.product-form__input');
        let changed = false;
        groups.forEach((g) => {
          changed = this.selectFirstVisibleEnabledInGroup(g) || changed;
        });
        return changed;
      }
      // ---------- END HELPERS ----------

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // Fix default selection if first/default is hidden or disabled
        // Delay to allow theme snippets to finish rendering
        requestAnimationFrame(() => this.ensureValidDefaults());

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
